
export const CallSilent = (props : any) => {
    return (
        <svg width={props.width || "20"} height={props.height || "20"} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m16.647 13.411-.605 2.625a.81.81 0 0 1-.794.63c-6.57 0-11.914-5.343-11.914-11.913 0-.382.26-.708.63-.793l2.626-.606a.817.817 0 0 1 .931.472l1.212 2.826a.815.815 0 0 1-.234.949L7.097 8.727a9.106 9.106 0 0 0 4.154 4.153l1.148-1.4a.81.81 0 0 1 .95-.235l2.826 1.212c.34.178.56.574.472.954z" fill="#33C" />
        </svg>

    );
}
